/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

window.initAccordion = function () {
  const containers = document.querySelectorAll('.accordion-section');
  if (!containers.length) return;

  containers.forEach(container => {
    const titles = container.querySelectorAll('.accordion-title');
    titles.forEach(title => {
      if (title.dataset.accordionInitialized) return;
      title.dataset.accordionInitialized = 'true';

      // Get content by aria-controls if already linked
      let contentId = title.getAttribute('aria-controls');
      let content = contentId ? document.getElementById(contentId) : null;

      // Fallback if not found or not valid
      if (!content || !content.classList.contains('accordion-content')) {
        content = title.nextElementSibling;
        const newId = `accordion-${Math.random().toString(36).substr(2, 9)}`;
        content.id = newId;
        title.setAttribute('aria-controls', newId);
      }

      // Set accessible attributes
      title.setAttribute('tabindex', '0');
      title.setAttribute('role', 'button');

      const isActive = title.classList.contains('active');
      title.setAttribute('aria-expanded', isActive);
      content.setAttribute('aria-hidden', !isActive);

const toggleAccordion = () => {
  const nowActive = !title.classList.contains('active');

  // Toggle ONLY this accordion (allow multiple open)
  title.classList.toggle('active', nowActive);
  title.setAttribute('aria-expanded', String(nowActive));
  content.setAttribute('aria-hidden', String(!nowActive));
};


      // Interaction handlers
      title.addEventListener('click', toggleAccordion);
      title.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ' || e.code === 'Space') {
          e.preventDefault();
          toggleAccordion();
        }
      });
    });
  });
};


document.addEventListener('DOMContentLoaded', function () {
  const hasAccordion = () => document.querySelector('.accordion-section');
  const isRelevantPage = () => {
    const path = window.location.pathname;
    return path.includes('/products/') || path.includes('/blogs/');
  };

  if (!isRelevantPage() || !hasAccordion()) return;

  window.initAccordion();

  // Debounced reinits on input/change events
  let debounce;
  const debouncedInit = () => {
    if (!hasAccordion()) return;
    clearTimeout(debounce);
    debounce = setTimeout(() => {
      window.initAccordion();
    }, 100);
  };

  document.body.addEventListener('change', (e) => {
    if (e.target.closest('.product-form')) debouncedInit();
  });

  document.body.addEventListener('input', (e) => {
    if (e.target.closest('.product-form')) debouncedInit();
  });

  // MutationObserver for dynamic content (e.g., translations)
  const observeTargets = document.querySelectorAll('.rte.text--pull, .product__description, main, [data-accordion]');

  observeTargets.forEach(target => {
    const observer = new MutationObserver(() => {
      if (!hasAccordion()) return;
      window.initAccordion();
    });

    observer.observe(target, {
      childList: true,
      subtree: true
    });
  });
});


(function() {
  function addAltToIcons(root) {
    root.querySelectorAll("img").forEach(function(img) {
      if (!img.hasAttribute("alt")) {
        img.setAttribute("alt", "");
      }
    });
  }

  // Initial run in case some icons are already in DOM
  addAltToIcons(document);

  // Watch for dynamically added icons
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) { // Element
          if (
            node.matches(".step-type-images, .rivo-card-icon, .rivo-th-tier-image, .launcher-desktop, .launcher-icon, .icon_with_text, .ba-met-handler") ||
            node.querySelector(".step-type-images, .rivo-card-icon, .rivo-th-tier-image, .launcher-desktop, .launcher-icon, .icon_with_text, .ba-met-handler")
          ) {
            addAltToIcons(node);
          }
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();



(() => {
  const BUTTON_SELECTOR = 'button[data-spec="toggle-button"]';
  const observedRoots = new WeakSet();

  function setAccessibleName(button) {
    if (!(button instanceof Element) || !button.matches(BUTTON_SELECTOR)) return;

    const expanded = button.getAttribute('aria-expanded') === 'true';
    const label = expanded ? 'Close chat' : 'Open chat';

    if (button.getAttribute('aria-label') !== label) {
      button.setAttribute('aria-label', label);
    }
  }

  function labelButtonsInRoot(root) {
    if (!root?.querySelectorAll) return;
    root.querySelectorAll(BUTTON_SELECTOR).forEach(setAccessibleName);
  }

  function scanForShadowRoots(node) {
    if (!(node instanceof Element)) return;

    const stack = [node];

    while (stack.length) {
      const current = stack.pop();

      if (!(current instanceof Element)) continue;

      setAccessibleName(current);

      if (current.shadowRoot) {
        observeRoot(current.shadowRoot);
      }

      for (const child of current.children) {
        stack.push(child);
      }
    }
  }

  function observeRoot(root) {
    if (!root || observedRoots.has(root)) return;
    observedRoots.add(root);

    labelButtonsInRoot(root);

    if (root instanceof Document) {
      scanForShadowRoots(root.documentElement);
    } else if (root instanceof ShadowRoot) {
      scanForShadowRoots(root.host);
      labelButtonsInRoot(root);
    }

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'attributes') {
          setAccessibleName(mutation.target);
          continue;
        }

        for (const node of mutation.addedNodes) {
          if (node instanceof Element) {
            scanForShadowRoots(node);
          }
        }
      }
    });

    observer.observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-expanded']
    });
  }

  function initChatAccessibilityPatch() {
    observeRoot(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initChatAccessibilityPatch, { once: true });
  } else {
    initChatAccessibilityPatch();
  }
})();





